export default {
  state: {
    userData: {},
    updateUser: false,
    userUnities: [],
    selectedData: {
      unity: "",
      profiles: [],
    },

    changeUnityProfileStatus: false,
    usersFilters: {},
    unityProfilesVisibility: false,
  },

  getters: {
    getUserData(state) {
      return state.userData;
    },

    getUserType(state) {
      return state.updateUser;
    },

    getSelectedUserData(state) {
      return state.selectedData;
    },

    getChangeUnityProfileStatus(state) {
      return state.changeUnityProfileStatus;
    },

    getUsersFilters: (state) => state.usersFilters,
    getUnityProfilesVisibility: (state) => state.unityProfilesVisibility,
  },

  mutations: {
    setUserData(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      state.userData = {
        id: isUpdate ? data.id : "",
        name: isUpdate ? data.name : "",
        socialName: isUpdate ? data.social_name : "",
        email: isUpdate ? data.email : "",
        cpf: isUpdate ? data.cpf : "",
        mainpPhone: isUpdate ? data.main_phone : "",
        alternativePhone: isUpdate ? data.alternative_phone : "",
        cellPhone: isUpdate ? data.cell_phone : "",
        registration: isUpdate ? data.registration : "",
        unityId: isUpdate ? parseInt(data.unity_id) : "",
        profileId: isUpdate ? parseInt(data.profile_id) : "",
        isUpdate: isUpdate,
      };
    },

    setSelectedUserData(state, data) {
      const checkData = Object.keys(data).length > 0;

      state.selectedData = {
        bindId: data.id,
        unity: checkData ? parseInt(data.unity_id) : "",
        profiles: checkData
          ? data.user_unity_profiles.map((profile) => profile.id)
          : [],
        isUpdate: checkData,
      };
    },

    setChangeUnityProfileStatus(state) {
      state.changeUnityProfileStatus = !state.changeUnityProfileStatus;
    },

    setChangeUsersFilters(state, filters) {
      state.usersFilters = filters;
    },

    setUnityProfilesVisibility(state, status) {
      state.unityProfilesVisibility = status;
    },
  },

  actions: {
    changeUserData(context, infos) {
      context.commit("setUserData", infos);
    },

    changeSelectedUserData(context, data) {
      context.commit("setSelectedUserData", data);
    },

    changeChangeUnityProfileStatus(context) {
      context.commit("setChangeUnityProfileStatus");
    },

    changeUsersFilters(context, filters) {
      context.commit("setChangeUsersFilters", filters);
    },

    changeUnityProfilesVisibility(context, status) {
      context.commit("setUnityProfilesVisibility", status);
    },
  },
};
